import React, { useState, useEffect } from "react";
import { useDesignFormStore, AstarState } from "../../store/DesignMasterStore";
import axiosApi from "../../server/service";
import SearchableDropdown from "../../components/customUI/SearchableDropdown";

interface DropdownOption {
  _id: string;
  astarType?: string;
  vendorName?: string;
}

interface VendorOption {
  _id: string;
  vendorName: string;
  contactNumber: string;
}

const AstarTab: React.FC = () => {
  const { astar, updateAstar, setAstarSpecs } = useDesignFormStore();

  const [fullAstarData, setFullAstarData] = useState<any[]>([]);

  const [astarOptions, setAstarOptions] = useState<
    { label: string; value: string }[]
  >([]);
  const [isLoadingAstars, setIsLoadingAstars] = useState(true);

  const [vendorOptions, setVendorOptions] = useState<
    { label: string; value: string }[]
  >([]);
  const [isLoadingVendors, setIsLoadingVendors] = useState(true);

  console.log(astar, "astar");

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    updateAstar(name as keyof typeof astar, value);
  };

  useEffect(() => {
    const fetchAstarTypes = async () => {
      setIsLoadingAstars(true);
      try {
        const response = await axiosApi.get("/api/astars/for-dropdown");
        if (response.data.success && Array.isArray(response.data.data)) {
          const allAstars = response.data.data;
          setFullAstarData(allAstars);

          const formatted = response.data.data.map((item: DropdownOption) => ({
            label: item.astarType!,
            value: item._id,
          }));
          setAstarOptions(formatted);
        }
      } catch (error) {
        console.error("Failed to fetch astar types:", error);
      } finally {
        setIsLoadingAstars(false);
      }
    };
    fetchAstarTypes();
  }, []);

  useEffect(() => {
    const fetchVendors = async () => {
      setIsLoadingVendors(true);
      try {
        const response = await axiosApi.get(
          "/api/vendors/getVendorsForDropdown",
          {
            params: { vendorType: "Fabric Supplier" },
          }
        );
        console.log("response", response);
        if (response.data.success && Array.isArray(response.data.data)) {
          // Format the API response for the Select component
          const formattedVendors = response.data.data.map(
            (vendor: VendorOption) => ({
              // label: `${vendor.vendorName}`,
              // value: `${vendor.vendorName}`,
              label: vendor.vendorName,
              value: vendor._id,
            })
          );
          setVendorOptions(formattedVendors);
        }
      } catch (error) {
        console.error("Failed to fetch vendors:", error);
        // You could add a toast notification here for the user
      } finally {
        setIsLoadingVendors(false);
      }
    };

    fetchVendors();
  }, []);

  const handleAstarSelect = (selectedId: string) => {
    const selectedAstar = fullAstarData.find((a) => a._id === selectedId);

    if (selectedAstar) {
      const vendorId = selectedAstar.vendorDetails?._id || null;
      const newSpecs: Partial<AstarState> = {
        astarType: selectedAstar._id,
        vendorDetails: vendorId,
        panna: selectedAstar.panna || "",
        pannaRate: selectedAstar.pannaRate?.toString() || "",
        agentName: selectedAstar.agentName || "",
        discountDetails: selectedAstar.discountDetails || "",
        masterRecordRef: selectedAstar.masterRecordRef || "",
      };
      setAstarSpecs(newSpecs); 
    }
  };

  return (
    <div className="bg-white p-2 rounded-xl">
      <h2 className="font-semibold text-2xl text-gray-800 mb-6">
        Astar Section
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* Astar Type/Name */}
        <div className="md:col-span-1">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Astar Type/Name
          </label>
          <SearchableDropdown
            options={astarOptions}
            value={astar.astarType || ""}
            // onChange={(value) => updateAstar("astarType", value)}
            onChange={handleAstarSelect}
            placeholder="Select or search astar..."
            loading={isLoadingAstars}
          />
        </div>

        {/* Chart Name */}
        <div className="md:col-span-1">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Chart Name
          </label>
          <input
            type="text"
            name="chartName"
            value={astar.chartName}
            onChange={handleChange}
            placeholder="e.g., Chart A"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
          />
        </div>

        {/* Chart No */}
        <div className="md:col-span-1">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Chart No.
          </label>
          <input
            type="text"
            name="chartNo"
            value={astar.chartNo}
            onChange={handleChange}
            placeholder="e.g., CH001"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
          />
        </div>

        {/* Vendor */}
        {/* <div className="md:col-span-1">
          <label className="block text-sm font-medium text-gray-700 mb-1">Vendor Details</label>
          <Select
            value={astar.vendorDetails}
            onValueChange={(value: string) => updateAstar("vendorDetails", value)}
          >
            <SelectTrigger className="w-full border border-gray-300 rounded-lg px-3 text-sm min-h-[44px] h-auto">
              <SelectValue placeholder="Select vendor" className="whitespace-normal text-left" />
            </SelectTrigger>
            <SelectContent className="bg-white shadow-lg rounded-lg border max-w-[90vw]">
              {vendorOptions.map((vendor) => (
                <SelectItem
                  key={vendor.value}
                  value={vendor.value}
                  className="cursor-pointer hover:bg-gray-100 py-2 px-3 rounded-md whitespace-normal break-words text-sm"
                >
                  {vendor.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div> */}

        <div className="md:col-span-1">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Vendor Details
          </label>

          <SearchableDropdown
            options={vendorOptions}
            value={astar.vendorDetails || ""}
            onChange={(value) => updateAstar("vendorDetails", value)}
            placeholder="Select or search vendor..."
            loading={isLoadingVendors}
          />
        </div>

        {/* Bill No */}
        <div className="md:col-span-2">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Bill No. with Date
          </label>
          <input
            type="text"
            name="billNoWithDate"
            value={astar.billNoWithDate}
            onChange={handleChange}
            placeholder="Bill number and date"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
          />
        </div>

        {/* Panna */}
        <div className="md:col-span-1">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Panna
          </label>
          <input
            type="text"
            name="panna"
            value={astar.panna}
            onChange={handleChange}
            placeholder="Panna details"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
          />
        </div>

        {/* Panna Rate */}
        <div className="md:col-span-1">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Panna Rate
          </label>
          <input
            type="number"
            name="pannaRate"
            value={astar.pannaRate}
            onChange={handleChange}
            placeholder="0.00"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
          />
        </div>

        {/* Agent Name */}
        <div className="md:col-span-1">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Agent Name
          </label>
          <input
            type="text"
            name="agentName"
            value={astar.agentName}
            onChange={handleChange}
            placeholder="Agent name"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
          />
        </div>

        {/* Discount */}
        <div className="md:col-span-1">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Discount Details
          </label>
          <input
            type="text"
            name="discountDetails"
            value={astar.discountDetails}
            onChange={handleChange}
            placeholder="Discount information"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
          />
        </div>

        {/* Master Reference */}
        <div className="md:col-span-3">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Master Record Reference
          </label>
          <input
            type="text"
            name="masterRecordRef"
            value={astar.masterRecordRef}
            onChange={handleChange}
            placeholder="Reference to master astar record"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
          />
        </div>

        {/* Notes */}
        <div className="md:col-span-3">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Additional Astar Notes
          </label>
          <textarea
            name="astarNotes"
            value={astar.astarNotes}
            onChange={handleChange}
            placeholder="Special instructions, care instructions, etc."
            className="w-full px-3 py-2 border border-gray-300 rounded-lg h-24"
          />
        </div>
      </div>
    </div>
  );
};

export default AstarTab;
